// pages/pays/PaysModal.jsx
import React, { useState } from 'react';
import api from '../../services/api';
import { X, AlertCircle } from 'lucide-react';

export default function PaysModal({ isOpen, onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({ Code: '', Nom: '', CodeTravail: '', FuseauHoraire: 'Africa/Casablanca', EstActif: true });

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    if (!formData.Code.trim() || !formData.Nom.trim()) { setError('Code et Nom sont obligatoires'); setLoading(false); return; }
    try {
      const response = await api.post('/pays', formData);
      if (response.data.success) { onSuccess(); onClose(); }
      else { setError(response.data.message); }
    } catch (err) { setError(err.response?.data?.message || 'Erreur lors de la création'); }
    finally { setLoading(false); }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-emerald-600">🌍 Nouveau pays</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X size={20} /></button>
        </div>
        {error && <div className="mb-4 p-3 bg-red-50 text-red-600 text-sm rounded-lg flex items-center gap-2"><AlertCircle size={16} /> {error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Code *</label>
              <input type="text" className="w-full p-2 border rounded-lg text-sm" value={formData.Code} onChange={(e) => setFormData({...formData, Code: e.target.value.toUpperCase()})} maxLength={3} placeholder="MA" required /></div>
            <div><label className="block text-sm font-medium text-gray-700 mb-1">Nom *</label>
              <input type="text" className="w-full p-2 border rounded-lg text-sm" value={formData.Nom} onChange={(e) => setFormData({...formData, Nom: e.target.value})} placeholder="Maroc" required /></div>
          </div>
          <div><label className="block text-sm font-medium text-gray-700 mb-1">Code du travail</label>
            <input type="text" className="w-full p-2 border rounded-lg text-sm" value={formData.CodeTravail} onChange={(e) => setFormData({...formData, CodeTravail: e.target.value})} /></div>
          <div><label className="block text-sm font-medium text-gray-700 mb-1">Fuseau horaire</label>
            <input type="text" className="w-full p-2 border rounded-lg text-sm" value={formData.FuseauHoraire} onChange={(e) => setFormData({...formData, FuseauHoraire: e.target.value})} /></div>
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" checked={formData.EstActif} onChange={(e) => setFormData({...formData, EstActif: e.target.checked})} className="w-4 h-4 text-emerald-500 rounded" />
            <span className="text-sm text-gray-700">Pays actif</span></label>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition text-sm">Annuler</button>
            <button type="submit" disabled={loading} className="flex-1 px-4 py-2 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition disabled:opacity-50 text-sm">{loading ? 'Création...' : 'Créer'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}